module.exports = __webpack_public_path__ + "public/media/digital-right.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-right.png
// module id = ./images/services/digital-right.png
// module chunks = 0